<template>
    <!-- 学习页面 -->
    <section class="onload">
        <Header @loadPage="onload"></Header>
        <div class="wrapper">
            <div class="locationM text-left">
                <Breadcrumb>
                    <img class="img" src="../assets/location.png" alt="">
                    当前位置：
                    <BreadcrumbItem to="/">首页</BreadcrumbItem>
                    <BreadcrumbItem>选修课程</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="innerM">
                <div class="title">
                    选修课程
                </div>
                <div class="inner-wrapper" v-if="$store.state.isLogin && isAlert == 1">
                    <div  v-for="(course, index) in courseList"  :key="index">
                        <div class="title2">
                            {{course.title}}
                        </div>
                        <div class="courseM">
                            <div class="col-20 course" v-for="(content, index2) in course.contentList" :key="index2" :data-id="content.contentId"  @click="courseClick">
                                <div class="cover inner pointer text-center">
                                    <img :src="content.cover" alt="">
                                </div>
                                <div class="name text-left inner pointer">
                                    <div class="col-100 name-text titleTxt">
                                      {{coursetitle(content.title)}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Alert class="alert" v-if="$store.state.isLogin && isAlert == -1" show-icon >
                  您目前还没有需要学习的课程
                  <template slot="desc">You don't have a course to learn at the moment. </template>
                </Alert>
                <Alert class="alert" type="error" v-if="!$store.state.isLogin" show-icon>
                  您需要登录后才能查看该内容
                  <span slot="desc">You need to be logged in to view this content.</span>
                </Alert>
            </div>
        </div>
        <Footer></Footer>
    </section>
</template>

<script>
    import Header from './components/Header'
    import Footer from './components/Footer'
    export default {
        name: "Learn",
        data(){
            return {
                isAlert:'',  //-1代表无课程，1代表有课程
                courseList: []
            }
        },
        mounted(){
            var that = this;
            that.onload();
            this.setTab();
        },
        methods: {
            onload(){
                //初始化
                var that = this;
                var token =  that.$cookie.get('xjaf-token');
                var username =  that.$cookie.get('xjaf-user');
                if(token != null && username != null){
                    that.httprequest();
                    that.$http({
                      url: that.webhost + 'user/checkStandard',
                      method: 'GET'
                    }).then(({data}) => {
                      if (data && data.code === 0 && data.data != 0) {
                        that.$store.commit('setAlertExam');
                        that.$store.commit('setSubjectCode', data.data);
                      }
                    })
                    //恢复滚动
                    $('body').removeAttr('style');
                }else{
                    this.$store.commit('login');
                }
            },
            httprequest(){
              var that = this;
              that.$store.state.tab = 1;
              var modelData = {
                "page": "1",
                "size": "10"
              };
              this.$http({
                url: that.webhost + 'course/courseListCode',
                method: 'POST',
                data: modelData
              }).then(({data}) => {
                if (data && data.code === 0) {
                  var tmp = data.data;
                  if (tmp.length > 0  ){
                      that.isAlert = 1;
                      that.courseList = tmp
                  } else {
                      that.isAlert = -1;
                  }
                } else {
                      that.$Message.error(data.msg)
                      that.isAlert = -1;
                }
              })
            },
            courseClick(e){
                this.$router.push(`/Course/${e.currentTarget.dataset.id}?type=1&subjectCode=${this.$store.state.subjectCode}`);
            }
        },
        components: {
            Header,
            Footer
        }
    }
</script>

<style scoped>
    .wrapper{
        width: 1200px;
        min-width: 1200px;
        margin: 0 auto;
        margin-top: 20px;
        margin-bottom: 70px;
        font-family: "PingFang SC";
    }
    .title{
        text-align: left;
        font-size: 25px;
        line-height: 72px;
        color: #000;
        border-bottom: solid 2px #ccc;
    }
    .title2{
        text-align: left;
        font-size: 21px;
        line-height: 70px;
        color: #000;
    }
    .locationM{
        height: 50px;
        line-height: 50px;
    }
    .locationM .ivu-breadcrumb{
        font-size: 15px;
        color: #000;
    }
    .locationM img{
        width: 23px;
        height: 22px;
        margin-right: 5px;
        position: relative;
        top: 3px;
    }
    .innerM{
        margin-top: 20px;
        min-height: 500px;
    }
    .courseM{
        width: 100%;
        text-align: left;
    }
    .course{
        display: inline-flex;
        flex-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        width: 20%;
        margin-bottom: 25px;
        padding-top: 7px;
    }
    .course:hover {
        border-color: #ddd;
        box-shadow: 1px 1px 2px 1px #ddd;
    }
    .course .inner{
        width: 95%;
        margin: auto;
    }

    .course .cover{
      position: relative;
    }
    .course .cover img{
        width: 95%;
        height: 128px;
    }
    .course .inner .progress{
      position: absolute;
      width: 95%;
      line-height: 25px;
      left: 2.5%;
      bottom: 5px;
      color: #fff;
      background-color: rgba(0, 0, 0, 0.79);
    }
    .course .btn{
        height: 30px;
        line-height: 30px;
        font-size: 16px;
    }
    .course .name{
        overflow: hidden;
        font-size: 15px;
        color: #000;
        padding: 5px 0 5px 2px;
        line-height: 30px;
    }
    .course .name .name-text{
      /*float: left;*/
    }
    .progress{
      float: right;
    }
    /* .titleTxt{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    } */
</style>



// WEBPACK FOOTER //
// src/views/Elective.vue